import { render, staticRenderFns } from "./RecapSection.vue?vue&type=template&id=55e52639&scoped=true&"
import script from "./RecapSection.vue?vue&type=script&lang=js&"
export * from "./RecapSection.vue?vue&type=script&lang=js&"
import style0 from "./RecapSection.vue?vue&type=style&index=0&id=55e52639&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e52639",
  null
  
)

export default component.exports